// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1QscV","alertIcon":"ConfirmModal_alertIcon__12J-6"};